<template>
  <div
    class="no-scrollbar -mx-4 flex shrink-0 items-center space-x-3 overflow-x-scroll px-4"
  >
    <CarouselCard
      v-for="(offer, idx) in offers"
      :key="idx"
      :offer="offer"
      :offer-idx="idx"
      :has-same-destination-city="hasSameDestinationCity"
      :source="`${source}.${idx}`"
      :cashback-click-source="cashbackClickSource"
      @click="handleCardClick(idx)"
      @onCashbackClick="emit('onCashbackClick')"
    />
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import type { specialOffers } from 'shared';

  import type { hotOffersTypes } from '@/entities/hot-offers';

  import type { analyticsEventsLib } from '@/shared/lib';

  import { buildSearchQuery, saveCitiesFromOffer } from '../model';
  import CarouselCard from './CarouselCard.vue';

  const props = defineProps<{
    offers: hotOffersTypes.MappedHotOffer[];
    currentSpecialOffer?: specialOffers.Special;
    hasSameDestinationCity?: boolean;
    source?: string;
    cashbackClickSource: analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource;
  }>();

  const emit = defineEmits<{
    onCashbackClick: [];
  }>();

  const router = useRouter();

  const handleCardClick = (offerIdx: number) => {
    const offer = props.offers[offerIdx];
    const { query: hashCode, source } = buildSearchQuery(
      offer,
      props.currentSpecialOffer,
    );
    saveCitiesFromOffer(offer);
    router.push({
      name: 'OffersResults',
      params: {
        hashCode,
        source,
      },
    });
  };
</script>
